export const AUTHORIZE_ROUTE_NAME = 'Authorize'

export default [
  {
    path: '/popup/:name/:id?',
    name: 'detailPopup',
    component: () => import(/* webpackChunkName:'detail' */ '@/pages/DetailPopup.vue'),
    meta: {
      rule: 'editor',
    },
  },
  {
    path: '/500',
    name: '500',
    component: () =>
      import(/* webpackChunkName:'pages' */
        '@/pages/404.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account/authorize',
    name: AUTHORIZE_ROUTE_NAME,
    component: () =>
      import(/* webpackChunkName:'account-authorize' */
        '@/pages/account/Authorize.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account/login',
    name: 'Login',
    component: () =>
      import(/* webpackChunkName:'account-login' */
        '@/pages/account/login/Index.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account/register',
    name: 'Register',
    component: () =>
      import(/* webpackChunkName:'account-register' */
        '@/pages/account/register/Index.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account/logout',
    name: 'Logout',
    component: () =>
      import(/* webpackChunkName:'account-logout' */
        '@/pages/account/Logout.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account/change-password',
    name: 'ChangePassword',
    component: () =>
      import(/* webpackChunkName:'account-change-password' */
        '@/pages/account/changePassword/ChangePassword.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/account/forgot-password',
    name: 'ForgotPassword',
    component: () =>
      import(/* webpackChunkName:'forgot-password' */
        '@/pages/account/forgotPassword/Index.vue'),
    meta: {
      anonymous: true,
    },
  },
]
